import React from "react";
import "../css/loader.css";

function Loader() {
  return (
    <div className="loader-wrapper">
      <div className="spinner"></div>
    </div>
  );
}

export default Loader;
